<template>
  <div>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4">
          <strong>Detail Obat</strong>
        </h5>
        <a-spin v-if="isLoading" />
        <a-form :form="form"  @submit="handleSubmit" v-if="!isLoading">
          <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="Nama Obat">
            <a-input
              :disabled="submitting"
              placeholder="Masukkan Nama Obat"
              v-decorator="['name', {rules: [{ required: true, message: 'Nama obat harus diisi!' }]}]"
            />
          </a-form-item>
          <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="Deskripsi">
            <a-input
              :disabled="submitting"
              placeholder="Masukkan deskripsi obat"
              v-decorator="['description', {rules: [{ required: true, message: 'Deskripsi obat harus diisi!' }]}]"
            />
          </a-form-item>
          <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="Status">
            <a-select
              :disabled="submitting"
              v-decorator="[
                'status',
                { rules: [{ required: true, message: 'Status harus diisi!' }] },
              ]"
              placeholder="Status"
            >
              <a-select-option v-for="status in statusList" :key="status.id" :value="status.id">
                  {{status.name}}
               </a-select-option>
            </a-select>
          </a-form-item>
          <button type="submit" class="btn btn-success px-5" :disabled="submitting">Simpan Data</button>
          <button class="btn btn-danger px-5 m-1" :disabled="submitting" @click="(e)=>{e.preventDefault(); setModalVisible(true)}">Hapus Data</button>
          <button class="btn btn-secondary px-5" :disabled="submitting" @click="handleCancel">Kembali</button>
        </a-form>
      </div>
    </div>
    <a-modal
      title="Konfirmasi"
      :dialog-style="{ top: '20px' }"
      :visible="modalVisible"
      @ok="() => handleDelete()"
      @cancel="() => setModalVisible(false)"
    >
      Apakah Anda yakin akan menonaktifkan data obat {{form.getFieldValue("name")}}?
    </a-modal>
  </div>
</template>
<script>

import router from '@/router'
import { getById, editById, deleteById } from '@/services/axios/api/obat'
import { getAll } from '@/services/axios/api/city'
import { notification } from 'ant-design-vue'

const labelCol = {
  xs: { span: 24 },
  sm: { span: 4 },
}
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 12 },
}
export default {
  data: function () {
    return {
      form: this.$form.createForm(this),
      labelCol,
      wrapperCol,
      cityList: [],
      isLoading: true,
      submitting: false,
      statusList: [{ id: 1, name: 'Aktif' }, { id: 0, name: 'Tidak Aktif' }],
      modalVisible: false,
    }
  },
  created() {
    this.getObatById()
    this.getCityList()
  },
  methods: {
    async getObatById() {
      // init form field
      this.form.getFieldDecorator('name', { initialValue: '' })
      this.form.getFieldDecorator('description', { initialValue: '' })
      this.form.getFieldDecorator('status', { initialValue: '' })
      // this.form.getFieldDecorator('hospital', { initialValue: '' })
      // this.form.getFieldDecorator('verificationCode', { initialValue: '' })
      // this.form.getFieldDecorator('idNumber', { initialValue: '' })

      // get data
      const res = await getById(this.$route.params.id)

      // set loading false
      this.isLoading = false

      if (res) {
        // set form data
        this.form.setFieldsValue({ name: res.name })
        this.form.setFieldsValue({ description: res.description })
        this.form.setFieldsValue({ status: res.status })
        // this.form.setFieldsValue({ hospital: res.hospital })
        // this.form.setFieldsValue({ verificationCode: res.verificationCode })
        // this.form.setFieldsValue({ idNumber: res.idNumber })
      }
    },
    async getCityList() {
      const res = await getAll()
      this.cityList = res
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.submitting = true
          console.log('Received values of form: ', values)
          try {
            const res = await editById(this.$route.params.id, values)
            if (res && res.data) {
              notification.success({
                message: 'Sukses',
                description: 'Data berhasil disimpan',
                duration: 5,
              })
              router.push('/obat')
            }
            this.submitting = false
          } catch (e) {
            this.submitting = false
          }
        }
      })
    },
    async handleDelete() {
      const res = await deleteById(this.$route.params.id)
      if (res && res.data) {
        notification.success({
          message: 'Sukses',
          description: 'Data berhasil dihapus',
          duration: 5,
        })
        router.push('/obat')
      } else {
        notification.warning({
          message: 'Gagal',
          description: 'Data gagal dihapus',
          duration: 5,
        })
      }
      this.submitting = false
      this.modalVisible = false
    },
    handleCancel(e) {
      e.preventDefault()
      router.push('/obat')
    },
    setModalVisible(modalVisible) {
      this.modalVisible = modalVisible
    },
  },
}
</script>
